// Auto-generated icon module
const svg = `<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
  <path d="M12,3c5,0,9,4,9,9c0,2.4-0.9,4.7-2.6,6.4c-3.5,3.5-9.2,3.5-12.7,0s-3.5-9.2,0-12.7l0,0C7.3,3.9,9.6,3,12,3 M12,2
    C6.5,2,2,6.5,2,12c0,5.5,4.5,10,10,10c5.5,0,10-4.5,10-10c0-2.7-1.1-5.2-2.9-7.1C17.2,3,14.7,2,12,2z" />
  <path d="M7.8,11.3h8.5c0.4,0,0.8,0.3,0.8,0.8l0,0c0,0.4-0.3,0.8-0.8,0.8H7.8C7.3,12.8,7,12.4,7,12l0,0C7,11.6,7.3,11.3,7.8,11.3z" />
</svg>
`;

export { svg as default };
//# sourceMappingURL=it-less-circle-CP6-Al2M.js.map
